import {Typography, Button, ButtonGroup} from "@one-thd/sui-atomic-components";
import { OptionsToggle } from "./index";
import React, {useContext, useState} from "react";
import { PasswordlessEnrollmentModal } from "./PasswordlessEnrollmentModal";
import { handleApiError } from "../../../../utils/errors";
import { getOTPv2 } from "../../../../api/custAccountApi";
import {
  isNativeApp,
  isPasswordlessEnrollmentForNativeAppOn,
  isWebAuthnEnabled,
  isWebauthnEnrollmentEnabledForNotNativeAppUsers
} from "../../../../utils/";
import { isDeviceWebAuthnCapable } from "../../../../utils/webauthnUtils";
import analytics from "../../../../utils/analytics";
import {PasswordContext} from "../../../../contexts/PasswordContext";
import {useNativeWebAuthnData} from "../../NativeWebAuthnProvider";

const WebauthnMessage = () => (
  <>
    <br/>
      <Typography align="justify" variant="body-base">
        After we verify that this is your account, you can sign in using your device’s biometric capability or a one-time passcode that we send to you.
      </Typography>
      <br/>
      <Typography align="justify">
        Your biometric data is only stored on your device and will not be sent to The Home Depot. Once enrolled you may opt out of this feature at any time by choosing to sign in with a password instead.
      </Typography>
    <br/>
  </>
)

const PasswordlessMessage = () => (
  <>
    <br/> 
    <Typography variant="body-base">
      Instead of entering a password you may sign into your account using a one-time passcode that we will send to you. After we verify that this is your account we will keep you signed in on this device for an extended period of time. 
    </Typography>
    <br/>
  </>
)

const PasswordOptions = (props) => {
  const {
    email,
    isUserPasswordlessEnrolled
  } = props;

  const {passwordOptions, setPasswordOptions} = useContext(PasswordContext);

  const [isCurrentDeviceWebAuthnCapable, setIsCurrentDeviceWebAuthnCapable] = React.useState(false);
  React.useEffect(()=> {
    if(isWebauthnEnrollmentEnabledForNotNativeAppUsers()){
      isDeviceWebAuthnCapable()
        .then((assessment)=>{
          setIsCurrentDeviceWebAuthnCapable(assessment)
        })
        .catch()
    }
  },[]);

  const { isDeviceCompatible, nativeWebAuthnData } = useNativeWebAuthnData();
  const isWebAuthnEnabledAndCompatible = isWebAuthnEnabled() && (isNativeApp() ? isDeviceCompatible : isCurrentDeviceWebAuthnCapable);

  /* Three stages: 
  1. stand-by
  2. getOTP
  3. verifyOTP
  4. Loading
  5. Sucess || Error
  */

  const [enrollmentStatus, setEnrollmentStatus] = useState("stand-by");
  const [encryptedPayload, setEncryptedPayload] = useState("");
  const [modalState , setModalState] = useState("info");
  const [open, setOpen] = useState(false);
  const [errors, setError] = useState([]);

  const handleGetOTPv2 = (email) => {
    setModalState("Loading");
    getOTPv2(email)
      .then(({ response, error })=>{
        setModalState("info");
        if(response?.data?.encryptedPayload) {
        // Successfully received encrypted payload from GET OTP request.
          setEncryptedPayload(response.data?.encryptedPayload)
        } else if (error) {
          const errorMessage = handleApiError(error, "passwordless enrollment");
          setError([errorMessage]);
        }
      })
  };
  
  const handleOpen = (email) => {
    // Handle the GET OTP Request and Enrollment Status.
    setEnrollmentStatus("getOTP");
    handleGetOTPv2(email);
    // Handle the modal.
    setOpen(true);
    analytics.postSettingsSubmissionEvent("passwordless enrollment start");
  };

  const handleClose = () => setOpen(false);

  const renderView = () => {
    if ((passwordOptions === "passwordless" && !isUserPasswordlessEnrolled)) {
      return (
        <> 
          { isWebAuthnEnabledAndCompatible ? <WebauthnMessage /> : <PasswordlessMessage /> }
          <ButtonGroup fullWidth>
              <Button onClick={ ()=>{ handleOpen(email) } } variant="primary"> Get Started </Button>
              <Button onClick={ ()=>{ setPasswordOptions("password") } } > Cancel </Button>
          </ButtonGroup>
        </>
      )
    }
  }

  return ( 
    <>
      <div className="col__12-12 u--paddingNone-horizontal u--paddingNone-bottom">
        { !isUserPasswordlessEnrolled && (isPasswordlessEnrollmentForNativeAppOn() || !isNativeApp()) && <div className="col__12-12 col__3-12--xs col__4-12--sm col__4-12--md col__4-12--lg u__bold u--paddingNone u--paddingSmall-right"><Typography variant="body-base" weight="bold"> Sign In Options </Typography></div>}
        {
          (!isUserPasswordlessEnrolled && (isPasswordlessEnrollmentForNativeAppOn() || !isNativeApp())) &&
          <div className="col__12-12 col__9-12--xs col__8-12--sm col__8-12--md col__8-12--lg u--paddingNone">
              <OptionsToggle isCurrentDeviceWebAuthnCapable={isWebAuthnEnabledAndCompatible} />
              { renderView() }
          </div>
        }
      </div>
            <PasswordlessEnrollmentModal 
              payload={encryptedPayload} 
              status={enrollmentStatus}
              setEnrollmentStatus={setEnrollmentStatus}
              email={email} 
              open={open}
              setEncryptedPayload={setEncryptedPayload}
              handleClose={handleClose}
              errors={errors}
              setError={setError}
              setModalState={setModalState}
              modalState={modalState}
              isCurrentDeviceWebAuthnCapable={isWebAuthnEnabledAndCompatible}
              isUserPasswordlessEnrolled={isUserPasswordlessEnrolled}
              nativeWebAuthnData={nativeWebAuthnData}
            />
    </>
  );
}
 
export default PasswordOptions;
